module.exports = __webpack_public_path__ + "img/featuredartist (5).b509f284.jpg";